
<template>
  <div class="box" ref="box" @touchend="getPlayTimeLength">
    <iframe class="size-helper" ref="sizeHelper" @resize="resizeVideo"></iframe>
    <div class="tips" v-if="noWifiTips">
      <i class="icon icon-play" @click="noWifiPlay"></i>
      <p>{{ getDict(10) }}</p>
    </div>
    <div
      ref="playerContainer"
      :id="`player-container-${id}`"
      class="player-container"
    ></div>
  </div>
</template>

<script>
// https://developers.google.com/youtube/iframe_api_reference

import { bus, getDict, axios, config } from "../common";
import { invokeNative } from "../common";
import { listen, unlisten } from "../common/invokeNative";
import { mapState, mapGetters } from "vuex";

let isYoutubeAPIReady = false;
let cannotUseYoutube = false;

const $script = document.createElement("script");
$script.src = "https://www.youtube.com/iframe_api";

window.onYouTubeIframeAPIReady = () => {
  isYoutubeAPIReady = true;
  bus.$emit("youtubeAPIReady");
};

document.body.appendChild($script);
//判断youtube是否能加载
$script.onerror = () => {
  cannotUseYoutube = true;
  bus.$emit("cannotUseYoutubeAPI");
};
$script.onload = () => {
  setTimeout(() => {
    if (!window.YT || !window.YTConfig) {
      cannotUseYoutube = true;
      bus.$emit("cannotUseYoutubeAPI");
    }
  }, 10);
};

let id = 1;

export default {
  props: {
    platform: String,
    videoId: String,
  },
  data() {
    return {
      id: id++,
      playerObj: null,
      gameStopPlayer: false,
      noWifiTips: false,
      playing: false,
      hasInit: false,
      canUseYoutube: true,

      playFromStartTime: 0,
    };
  },
  computed: {
    ...mapState(["goingTime"]),
  },
  watch: {
    videoId() {
      let changeVideo = () => {
        if (this.playerObj && this.playerObj.cueVideoById) {
          this.playerObj.cueVideoById({
            videoId: this.videoId,
          });
          if (!this.noWifiTips && this.videoId) {
            this.playerObj.playVideo();
          }
        } else {
          if (this.hasInit) {
            setTimeout(() => {
              changeVideo();
            }, 100);
          }
        }
      };
      changeVideo();
      this.logView();
      this.playFromStartTime = 0;
    },
    playerObj() {
      this.getPlayTimeLength();
    },
    playFromStartTime() {
      bus.$emit("videoPlayTimeChange", this.playFromStartTime);
    },
    goingTime() {
      this.timer();
    },
  },
  methods: {
    getDict,
    timer() {
      this.getPlayTimeLength();
    },
    getPlayTimeLength() {
      if (this.playerObj && this.playerObj.getCurrentTime) {
        let time = this.playerObj.getCurrentTime();
        this.playFromStartTime = Math.floor(time * 1000);
      }
    },
    playerVideo() {
      let play = () => {
        if (this.playerObj && this.playerObj.playVideo) {
          this.playerObj.playVideo();
        } else {
          if (this.hasInit) {
            setTimeout(() => {
              play();
            }, 100);
          }
        }
      };
      play();
    },
    noWifiPlay() {
      this.noWifiTips = false;
      this.playerVideo();
    },
    onGamePause() {
      if (this.playing) {
        this.gameStopPlayer = true;
      }
      this.playerObj.pauseVideo();
    },
    onGameResume() {
      if (this.gameStopPlayer) {
        this.gameStopPlayer = false;
        this.playerVideo();
      }
    },
    initPlayer() {
      const $player = this.$refs.playerContainer;
      this.hasInit = true;
      this.playerObj = new YT.Player(`player-container-${this.id}`, {
        width: $player.clientWidth,
        height: $player.clientHeight,
        videoId: this.videoId,
        playerVars: {
          playsinline: 1,
          autoplay: 1,
          fs: 0,
          rel: 0,
        },
        events: {
          // 'onReady': onPlayerReady,
          // 'onPlaybackQualityChange': onPlayerPlaybackQualityChange,
          onStateChange: (res) => {
            let status = res.data;
            console.log("youtubeStateChange", status);

            switch (status) {
              case YT.PlayerState.PLAYING:
                this.stopMusic();
                this.playing = true;
                break;
              case YT.PlayerState.PAUSED:
                this.playing = false;
                if (!this.gameStopPlayer) {
                  //以为游戏到后台而暂停则不需要播放游戏音乐
                  this.startMusic();
                }

                break;
            }
          },
          // 'onError': onPlayerError
        },
      });

      listen("onGamePause", this.onGamePause);
      listen("onGameResume", this.onGameResume);
      this.$emit("playerInited");
    },
    stopMusic() {
      console.log("stopMusic");
      invokeNative(
        "stopGameMusic",
        {},
        (res) => {
          // 执行成功
        },
        (res) => {
          //执行失败
        }
      );
    },
    startMusic() {
      console.log("startMusic");
      invokeNative(
        "playGameMusic",
        {},
        (res) => {
          // 执行成功
        },
        (res) => {
          //执行失败
        }
      );
    },
    logView() {
      // console.log(123)
      if (config.videoPlayCount) {
        if (config.videoPlayCount.url) {
          axios
            .get(config.videoPlayCount.url + "/uslog", {
              params: {
                body: JSON.stringify({
                  videoID: this.videoId,
                }),
                head: "unisdk_cattle_b",
              },
            })
            .then((res) => {})
            .catch((error) => {});
        }
      } else {
        config.afterInit(() => {
          this.logView();
        });
      }
    },
    resizeVideo() {
      let $player = this.$refs.box;
      if (!$player) {
        return;
      }
      this.playerObj.setSize($player.clientWidth, $player.clientHeight);
    },
  },
  mounted() {
    try {
      this.$refs.sizeHelper.contentWindow.addEventListener(
        "resize",
        this.resizeVideo
      );
    } catch (e) {}

    if (true || this.platform === "youtube") {
      if (!cannotUseYoutube) {
        bus.$once("cannotUseYoutubeAPI", () => {
          this.canUseYoutube = false;
        });
      } else {
        this.canUseYoutube = false;
      }
      if (!isYoutubeAPIReady) {
        bus.$once("youtubeAPIReady", this.initPlayer);
      } else {
        this.initPlayer();
      }
    }
    this.$busOn("setRemUnit", () => {
      //$busOn
      // console.log(123123)
      let $player = this.$refs.box;
      if (!$player) {
        return;
      }
      // this.playerObj.setSize($player.clientWidth,$player.clientHeight);
    });
    this.getPlayTimeLength();
  },
  created() {
    // setTimeout(()=>{this.playerVideo()},2000)

    invokeNative(
      "getNetworkType",
      {},
      (res) => {
        if (res.errno == 0) {
          this.noWifiTips = res.message != 1;
          if (!this.noWifiTips) {
            if (this.hasInit) {
              this.playerVideo();
            } else {
              bus.$once("playerInited", () => {
                this.playerVideo();
              });
            }
          }
        }
      },
      (res) => {
        //执行失败
      }
    );
    if (this.videoId) {
      this.logView();
    }
  },
  beforeDestroy() {
    unlisten("onGamePause", this.onGamePause);
    unlisten("onGameResume", this.onGameResume);
    this.$refs.sizeHelper &&
      this.$refs.sizeHelper.contentWindow &&
      this.$refs.sizeHelper.contentWindow.removeEventListener("resize");
  },
};
</script>

<style lang="scss" scoped>
.box {
  width: 100%;
  position: relative;
  // height: 100%;

  .size-helper {
    position: absolute;
    padding: 0;
    margin: 0;
    border: 0;
    height: 100%;
    width: 100%;
    z-index: -1;
  }
  .tips {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    background-color: #232324;
    align-items: center;

    .icon-play {
      $width: 0.9rem;
      $height: $width/67 * 54;
      width: $width;
      height: $height;
    }
    p {
      margin-top: 0.3rem;
      color: #818181;
      font-size: 0.3rem;
    }
  }
}
.player-container {
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
}
</style>
